import styles from 'theme/features/dashboard/components/dashboard-comparison-card.module.scss';

const DashboardComparisonCard = ({ children }) => <article className={styles.card}>{children}</article>;

export default DashboardComparisonCard;
